import {
    ActivityTrackerApi,
    ClientCompanyApi,
    Configuration,
    ExpenseApi,
    ProjectBillingInfoApi,
    ProjectClientApi,
    ProjectClientListApi,
    PurchaseOrderApi,
    ProjectClientQuoteApi,
    ClientAccountApi,
    ConversationalAgentApi,
    ProjectTermsApi,
} from '@api';

const configuration = new Configuration({basePath: ''});

export const projectListEndpoints = new ProjectClientListApi(configuration);

export const activityTrackerEndpoints = new ActivityTrackerApi(configuration);

export const projectInformationEndpoints = new ProjectClientApi(configuration);

export const clientAccountEndpoints = new ClientAccountApi(configuration);

export const clientCompanyEndpoints = new ClientCompanyApi(configuration);

export const clientExpenseEndpoints = new ExpenseApi(configuration);

export const purchaseOrderUpdateEndpoints = new PurchaseOrderApi(configuration);

export const projectBillingInfoEndpoints = new ProjectBillingInfoApi(configuration);

export const projectTermsEndpoints = new ProjectTermsApi(configuration);

export const quoteEndpoints = new ProjectClientQuoteApi(configuration);

export const conversationalAgentEndpoints = new ConversationalAgentApi(configuration);
